const SUBSCRIPTION_STATES = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  GRACE: 'GracePeriod',
  PENDING: 'Pending',
}

export default SUBSCRIPTION_STATES
